import { type ResearchRequestInitialPropertyData } from "@/features/realEstateResearchRequest/types";
import { type BookTypeEng } from "@/types/acquirebook";
import { type PropertySelectionRow } from "../types";

interface BuildInput {
  prefecture: string;
  address: string;
  chibanOrKaokuNumber: string;
  location: string;
  fromPopup?: boolean;
  bookType?: BookTypeEng;
  selectedProperties: PropertySelectionRow[];
}

export const buildRealEstateRequestInitialPropertyData = ({
  prefecture,
  address,
  chibanOrKaokuNumber,
  location,
  fromPopup = false,
  bookType,
  selectedProperties,
}: BuildInput): ResearchRequestInitialPropertyData => {
  if (fromPopup) {
    const row = {
      prefName: prefecture,
      location,
      chibanAndKaokuNumber: chibanOrKaokuNumber,
    };
    const isLand = bookType === undefined || bookType === "LAND";
    return {
      address,
      chibanList: isLand ? [row] : [],
      kaokuNumberList: isLand ? [] : [row],
    };
  }

  const toPropertyRow = (
    row: PropertySelectionRow
  ): ResearchRequestInitialPropertyData["chibanList"][number] => ({
    prefName: row.prefName,
    location: row.location,
    chibanAndKaokuNumber: row.chibanKaokuNumber,
  });
  return {
    address,
    chibanList: selectedProperties
      .filter((row) => row.selected && row.bookType === "LAND")
      .map(toPropertyRow),
    kaokuNumberList: selectedProperties
      .filter((row) => row.selected && row.bookType === "BUILDING")
      .map(toPropertyRow),
  };
};
